<template>
  <div v-show="ibox.visible">
    <div
      class="modal"
      style="display: block; background: rgba(0, 0, 0, 0.4)"
    ></div>
    <div
      class="modal-dialog"
      style="position: fixed; left: 400px; top: 150px; z-index: 8888"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="closeAlertBoxDlg()">
            ×
          </button>
          <!--
          <h4 class="modal-title" style="color: black">{{ ibox.title }}</h4>
          -->
          <h4 class="modal-title" style="color: black">
            {{ ibox.type === "info" ? "message" : "warning" }}
          </h4>
        </div>
        <div class="modal-body">
          <div style="margin: 5px; display: flex">
            <!--            
            <span
              class="glyphicon icon-alertbox-size"
              id="icon"
              :class="{
                'glyphicon-info-sign icon-severity-info':
                  ibox.type === 'info',
                'glyphicon-warning-sign icon-severity-warn':
                  ibox.type === 'warn',
                'glyphicon-remove-sign icon-severity-alert':
                  ibox.type === 'critical',
              }"
            ></span>
            -->
            <span
              class="glyphicon icon-alertbox-size"
              id="icon"
              :class="{
                'glyphicon-info-sign icon-severity-info': ibox.type === 'info',
                'glyphicon-warning-sign icon-severity-warn':
                  ibox.type !== 'info',
              }"
            ></span>
            <span style="margin: 3px 15px">{{ ibox.txt }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button
            class="btn btn-primary"
            type="button"
            @click="closeAlertBoxDlg()"
          >
            {{ ibox.btxt }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "infoBox",

  data() {
    return {}
  },
  props: {
    ibox: {
      type: Object,
      default: function () {
        return {
          visible: false,
          type: "info",
          title: "Info",
          text: "",
          btxt: "Close",
        }
      },
    },
  },
  methods: {
    closeAlertBoxDlg() {
      this.ibox.visible = false
    },
  },
}
</script>

<style lang="less" scoped>
</style>
 
